import { useCallback, useEffect } from "preact/hooks";
import { scanAccProjectPackage } from "../lib/scanAccPackage";
import { useAccBrowseStore } from "../stores/accBrowseStore";
import { usePackageInventoryStore } from "../stores/packageInventoryStore";
import { useSrProfileStore } from "../stores/srProfileStore";
import { useDataManagementService } from "./useDataManagementService";

/** Whole-project submission file inventory once hub + project are selected. */
export function useAccPackageScan(enabled: boolean) {
  const dm = useDataManagementService();
  const hub = useAccBrowseStore(s => s.hub);
  const project = useAccBrowseStore(s => s.project);

  const runScan = useCallback(async () => {
    if (!enabled || !hub || !project) return;
    const inv = usePackageInventoryStore.getState();
    inv.setScanning();
    try {
      const { files, foldersVisited } = await scanAccProjectPackage(
        dm,
        hub,
        project
      );
      inv.setInventory(files, foldersVisited);
    } catch (e) {
      inv.setError(e instanceof Error ? e.message : "Package scan failed");
    }
  }, [enabled, hub, project, dm]);

  useEffect(() => {
    if (!enabled || !hub || !project) {
      usePackageInventoryStore.getState().clear();
      return;
    }
    useSrProfileStore.getState().bindAccProject(hub.id, project.id);
    void runScan();
  }, [enabled, hub?.id, project?.id, runScan]);

  return { runScan };
}
